import { formatCurrency } from '../../utils/formatters';

/** Marca discreta de un monto corregido en un movimiento con comprobante (spec, /grill-me). */
export const MontoCorregido: React.FC<{ readonly montoOriginal: number }> = ({ montoOriginal }) => (
  <span className="block text-xs text-slate-500">Monto corregido · antes {formatCurrency(montoOriginal)}</span>
);
